import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "hyphenationproperties"
    }}>{`HyphenationProperties`}</h1>
    <p>{`These property values are used to apply hyphenation to paragraph text.`}</p>
    <p>{`These hyphenation features can be seen in the dialog
in the Paragraph panel's flyout menu item labeled "Hyphenation...".
They are expressed with an object literal with the following properties (values are in pixels):`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{    
     // The minimum number of letters a word must have in order for hyphenation
     // in word wrap to be allowed. In the range [2, 25], default 5.
     wordsLongerThan: number,
     // The minimum number of letters after which hyphenation
     // in word wrap is allowed. In the range [1, 15], default 2.
     afterFirst: number,
     // The minimum number of letters before which hyphenation
     // in word wrap is allowed. In the range [1, 15], default 2.
     beforeLast: number,
     // The maximum number of consecutive lines that can end with a hyphenated word.
     // In the range [2, 25], default 2.
     limit: number,
     // The distance in pixels at the end of a line that will cause a word 
     // to break in unjustified type. In the range of [0, 8640] pixels for a 72PPI document.
     // If the document resolution is different, the max. value is scaled accordingly.
     // Default: 36px (72PPI) 
     zone: number,
    // True to allow hyphenation in word wrap of capitalized words. Default true.
     capitalWords: boolean
}
`}</code></pre>
    <p>{`The hyphenationFeatures getter returns an object with all the features:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const textItem = app.activeDocument.activeLayers[0].textItem;
textItem.paragraphStyle.hyphenationFeatures; 
// { 
//       wordsLongerThan: 5, 
//       afterFirst: 2, 
//       beforeLast: 2, 
//       limit: 2, 
//       zone: 36, 
//       capitalWords: true 
// }
`}</code></pre>
    <p>{`In the object that is passed to the setter, all the properties are optional;
the ones that are not specified will be assigned the default values.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`textItem.paragraphStyle.hyphenationFeatures = { wordsLongerThan: 10, afterFirst: 3 };
// { 
//       wordsLongerThan: 10, 
//       afterFirst: 3, 
//       beforeLast: 2, 
//       limit: 2, 
//       zone: 36, 
//       capitalWords: true 
// }
`}</code></pre>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Range`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Min Version`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`afterFirst`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1..15`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.1`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The minimum number of letters after which hyphenation in word wrap is allowed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`beforeLast`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1..15`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.1`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The minimum number of letters before which hyphenation in word wrap is allowed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`capitalWords`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`true`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.1`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`True to allow hyphenation in word wrap of capitalized words.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`limit`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2..25`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.1`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The maximum number of consecutive lines that can end with a hyphenated word.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`wordsLongerThan`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`5`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2..25`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.1`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The minimum number of letters a word must have in order for hyphenation in word wrap to be allowed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`zone`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`36`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0..8640 for a 72PPI document`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`24.1`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The distance in pixels at the end of a line that will cause a word to break in unjustified type.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      